export const COMMENT_RESOURCE_TYPE = {
  QUESTION_ANSWER: "QUESTION_ANSWER",
  POST: "POST",
  ANNOTATION: "ANNOTATION",
  ATTEMPT_HISTORY: "ATTEMPT_HISTORY",
  TEAM_ATTEMPT_HISTORY: "TEAM_ATTEMPT_HISTORY",
  QUESTION: "QUESTION",
  ACTIVITY_QUIZ: "ACTIVITY_QUIZ",
  CONVERSATION: "CONVERSATION",
};

export const COMMENT_POLLING_INTERVAL = 60000;

// Only Question Attempt comments require academic year
// Post comments and Annotation comments do not need and use academic year. thus dummy value is used.
export const ACADEMIC_YEAR_FOR_POST_OR_ANNOTATION_COMMENTS = 0;

export const COMMENT_ANCHOR_RESOURCE_TYPE = {
  QUESTION: "QUESTION",
  LESSON_COMPONENT: "LESSON_COMPONENT",
};

export const WCPM_REGEX =
  /<(p|div)\b[^>]*>\s*(?:每分钟正确朗读字数|Jumlah Perkataan Tepat Per Minit|ஒரு நிமிடத்தில் படிக்கப்பட்ட சரியான சொற்களின் எண்ணிக்கை)\s*:\s*[^<]*<\/\1>/gi;
